/**
 * The external dependencies.
 */
import React from 'react';
import {connect} from 'react-redux';
/**
 * The internal dependencies.
 */
import Grid from '../../../containers/dashboard/grid';
import Task from '../../../containers/disponent';
import {getFormattedTasksColumns, getTaskColumnsAndTasks} from '../../../store/tasks/selectors';
import {dispoGetDepartments, dispoGetUser} from "../../../store/dispo/actions";
import {getworkstepcount} from "../../../store/tasks/actions";

class DisponentGrid extends React.Component {


    componentDidMount() {
        // const {qualityGetTasks} = this.props;
        // qualityGetTasks()
        const {dispoGetUser, dispoGetDepartments, getworkstepcount} = this.props;
        dispoGetUser();
        dispoGetDepartments();
        getworkstepcount();
    }

    render() {
        const {taskscolumns} = this.props;
        const {tasks, columns} = taskscolumns;
        let allowedStatuses = [null, 'reserved', '', 'done', 'in-progress', 'failed'];
        return (
            <Grid
                tasks={tasks}
                columns={columns}
                taskComponent={Task}
                allowedStatuses={allowedStatuses}
                isDispo={true}
            />
        );
    }
}

export default connect(
    state => ({
        // tasks: getTasksFormattedItems(state),
        // columns: getTaskColumns(state, getTasksFormattedItems),
        taskscolumns: getFormattedTasksColumns(state),
    }), {
        dispoGetUser,
        dispoGetDepartments,
        getworkstepcount
    }
)(DisponentGrid);



// WEBPACK FOOTER //
// ./src/containers/dashboard/grid/disponent.js